import { GridColumnProps } from "@progress/kendo-react-grid";
import { CellWrapper, InstrumentCell, RankingCell, ValueCell } from "./cells";
import { DisplayItem } from "@iliotech/watchlist-api";

const makeCamelCase = (s: string) =>
  (s?.[0] || "") + s.slice(1).toLowerCase().replace("_", " ");
export const MarketInsightsColumns = (
  otherFields: string[],
  onInstrumentClick: (id: DisplayItem) => void,
  findCategoryIdByField?: (field: string) => string | undefined | null,
  isDefault?: (field: string) => boolean
) =>
  [
    {
      order: 1,
      field: "Ranking",
      title: "Ranking",
      width: 80,
      sortable: false,
      locked: true,
      isDefault: true,
      mandatory: true,
      cell: (props) => (
        <CellWrapper
          rightAligned={false}
          gridCellProps={props}
          cell={RankingCell}
          field={"ranking"}
          dataItem={props.dataItem}
        />
      ),
    },
    {
      order: 2,
      field: "Ticker",
      title: "Ticker",
      width: 200,
      locked: true,
      sortable: false,
      mandatory: true,
      isDefault: true,
      cell: (props) => (
        <CellWrapper
          gridCellProps={props}
          cell={InstrumentCell}
          onClick={onInstrumentClick}
          dataItem={props.dataItem}
          field={"label"}
        />
      ),
    },
    ...otherFields?.map((item, index) => ({
      field: item,
      title: item,
      width: 150,
      order: index + 3,
      rightAligned: true,
      isDefault: isDefault?.(item),
      group:
        item === "Sector"
          ? "General"
          : makeCamelCase(findCategoryIdByField?.(item) || ""),
      cell: (props: any) => (
        <CellWrapper
          rightAligned={true}
          dataItem={props.dataItem}
          field={item}
          cell={ValueCell}
          gridCellProps={props}
        />
      ),
    })),
  ] as (GridColumnProps & {
    group?: string;
    isDefault: boolean;
    order?: number;
  })[];
